import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { selectorArg1 } from '../utils/selectors';
import { IWorkspaceSlice } from '../slices/workspace';

export const workspaceSelector = (rootState: RootState) => rootState.workspace;

export const workspacePropertySelector = createSelector(
  workspaceSelector,
  selectorArg1<keyof IWorkspaceSlice>(),
  (workspace, propKey) => workspace[propKey],
);
